<agpr-dialog-container
    [id]="'wirePreviewDialog'"
    heading="Amplify.wire.actions.preview"
    [modal]="true"
    [draggable]="false"
    [contentPadding]="false"
    (close)="closeDialog()"
>
    <div class="agpr-wirePreview-container">
        <agpr-message
            class="agpr-wirePreview-info"
            severity="info"
        >
            {{'Amplify.wire.actions.preview.disclaimer' | localize}}
        </agpr-message>
        <div
            class="agpr-wirePreview-screenPreview"
        >
        <agpr-scroll-panel class="agpr-wirePreview-panel">
            <div class="agpr-wirePreview-headerLogoContainer">
                <div class="agpr-wirePreview-headerContainer">
                    <agpr-shadow-dom-container [customHtml]="headerHtml"></agpr-shadow-dom-container>
                </div>
                <div class="agpr-wirePreview-logoContainer">
                    <agpr-shadow-dom-container [customHtml]="logoHtml"></agpr-shadow-dom-container>
                </div>
            </div>
            <div class="agpr-wirePreview-frame">
                <agpr-shadow-dom-container [customHtml]="body"></agpr-shadow-dom-container>
            </div>
        </agpr-scroll-panel>
        </div>
    </div>
    <ng-template #footerRight>
        <agpr-button
            id="wirePreviewDialog.doneButton"
            label="done"
            (click)="closeDialog()"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>
